document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-card-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const image = gallery.querySelector('.drop-card__image-main');
    const thumbs = Array.from(gallery.closest('.product-card-link')?.querySelectorAll('[data-gallery-thumb]') || []);
    const images = JSON.parse(gallery.dataset.galleryImages || '[]').filter(Boolean);

    if (!image || images.length <= 1) return;

    let currentIndex = 0;
    let touchStartX = 0;
    let touchDeltaX = 0;
    let swipeTriggered = false;
    let animationLock = false;

    const preloadImage = (src) => {
      if (!src) return;
      const preloader = new Image();
      preloader.decoding = 'async';
      preloader.src = src;
    };

    const setActiveThumb = () => {
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('is-active', index === currentIndex);
      });
    };

    const animateSwap = (nextSrc, direction = 1) => {
      if (!nextSrc || image.src === nextSrc || animationLock) return;

      animationLock = true;

      if (typeof image.animate !== 'function') {
        image.src = nextSrc;
        setActiveThumb();
        animationLock = false;
        return;
      }

      const distance = direction > 0 ? 24 : -24;
      const outgoing = image.animate(
        [
          { opacity: 1, transform: 'translate3d(0,0,0)' },
          { opacity: 0, transform: `translate3d(${distance}px, 0, 0)` }
        ],
        { duration: 220, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' }
      );

      outgoing.finished
        .catch(() => {})
        .then(() => {
          image.src = nextSrc;
          preloadImage(images[(currentIndex + 1) % images.length]);

          return image.animate(
            [
              { opacity: 0, transform: `translate3d(${distance * -1}px, 0, 0)` },
              { opacity: 1, transform: 'translate3d(0,0,0)' }
            ],
            { duration: 220, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' }
          ).finished.catch(() => {});
        })
        .finally(() => {
          image.style.opacity = '1';
          image.style.transform = 'translate3d(0,0,0)';
          setActiveThumb();
          animationLock = false;
        });
    };

    const goToIndex = (index) => {
      if (index < 0 || index >= images.length || index === currentIndex) return;
      const direction = index > currentIndex ? 1 : -1;
      currentIndex = index;
      animateSwap(images[currentIndex], direction);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goToIndex(Number(thumb.dataset.galleryThumb));
      });
    });

    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0].clientX;
      touchDeltaX = 0;
      swipeTriggered = false;
    }, { passive: true });

    gallery.addEventListener('touchmove', (event) => {
      touchDeltaX = event.touches[0].clientX - touchStartX;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      const threshold = 36;

      if (Math.abs(touchDeltaX) < threshold) return;

      event.preventDefault();
      event.stopPropagation();
      swipeTriggered = true;

      currentIndex = (currentIndex + (touchDeltaX < 0 ? 1 : -1) + images.length) % images.length;
      animateSwap(images[currentIndex], touchDeltaX < 0 ? 1 : -1);
    });

    gallery.addEventListener('click', (event) => {
      if (!swipeTriggered) return;
      event.preventDefault();
      event.stopPropagation();
      swipeTriggered = false;
    }, true);

    setActiveThumb();
    preloadImage(images[1]);
  });
});
